'use client'
import dynamic from 'next/dynamic'
import type { StateCountBubble } from './ShaheedStateMap'

/* Thin client wrapper so the server-rendered archive can mount the Leaflet map client-only
   (Leaflet needs `window`, so dynamic({ ssr:false }) must live in a client file).

   Faheem's decision: the archive maps STATE COUNTS, not pins. Shaheed records carry provable
   city/district/state text but no coordinates — a geocoded pin would quietly claim "the masjid
   stood HERE", which we cannot back for demolished masjids on contested ground. So NO forward
   geocoding, NO centroid-as-location, NO invented coordinates: ShaheedStateMap renders
   "State · count" bubbles at static label centroids, and clicking one filters the list via the
   existing ?state= param. */

const ShaheedStateMap = dynamic(() => import('./ShaheedStateMap'), {
  ssr: false,
  loading: () => (
    <div style={{ height: 320, display: 'grid', placeItems: 'center', color: 'rgba(231,227,214,.55)', fontSize: 13 }}>
      Loading map…
    </div>
  ),
})

export default function ShaheedArchiveMap({ groups, height }: { groups: StateCountBubble[]; height?: number }) {
  return <ShaheedStateMap groups={groups} height={height} />
}
